export enum CashRequestStatus {
  AVAILABLE = "Disponible",
  IN_PROCESS = "En proceso",
  NEEDS_INFO = "Requiere información",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  SCHEDULED = "Programada",
}

export enum CheckRequestStatus {
  AVAILABLE = "Disponible",
  IN_PROCESS = "En proceso",
  NEEDS_INFO = "Requiere información",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
}

export enum TransferRequestStatus {
  PENDING = "En curso",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  FAILED = "Fallida",
}

export enum TransferExternalStatus {
  PENDING = "Pendiente",
  FAILED = "Fallida",
  FINISHED = "Finalizada",
}

export enum ScheduledTransferStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  ON_REVISION = "En revisión",
  FAILED = "Fallida",
  SCHEDULED = "Programada",
}

export enum SlotStatus {
  PENDING = "Pendiente",
  NO_TRANSPORT = "Sin flete",
  ASSIGNED = "Asignado",
  DELIVERED = "Entregado",
  TRANSIT = "En tránsito",
  FINISHED = "Finalizado",
}

export enum SellOrderStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  IN_PROCESS = "En proceso",
  CANCELLED = "Cancelada",
  NEGOTIATION = "Negociación",
  IN_COMMUNICATION = "En comunicación",
  CONFIRMED = "Confirmada",
}

export enum CounterDeliveryStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  IN_PROCESS = "En proceso",
  IN_COMMUNICATION = "En comunicación",
  CANCELLED = "Cancelada",
  NEGOTIATION = "Negociación",
  CONFIRMED = "Confirmada",
}

export enum FutureContractStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  IN_PROCESS = "En proceso",
  IN_COMMUNICATION = "En comunicación",
  CANCELLED = "Cancelada",
  NEGOTIATION = "Negociación",
  CONFIRMED = "Confirmada",
}

export enum SlotRequestStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  PENDING = "Pendiente",
  SLOTS_PARTIALLY_ASSIGNED = "Cupos asignados parcialmente",
  SLOTS_ASSIGNED = "Cupos asignados",
  NEEDS_INFO = "Requiere información",
}

export enum BackupCheckStatus {
  PENDING_CHECK = "Pendiente de cheque",
  PENDING_ENDOSE = "Pendiente de endoso",
  FINISHED = "Finalizado",
  CANCELLED = "Cancelado",
}

export enum OrderStatus {
  PENDING = "Pendiente",
  CONFIRMED = "Confirmado",
  DELIVERED = "Entregado",
  TRANSIT = "En camino",
}

export enum SuppliesRequestStatus {
  PENDING = "Pendiente",
  NEEDS_INFO = "Requiere información",
  ORDER_CREATED = "Pedido creado",
  PARTIALLY_CONFIRMED = "Confirmado parcial",
  ORDER_CONFIRMED = "Pedido confirmado",
  IN_TRANSIT = "En camino",
  PARTIAL_DELIVERY = "Entrega parcial",
  DELIVERED = "Entregado",
  REJECTED = "Rechazada",
  CANCELLED = "Cancelada",
}

export enum SuppliesOrderStatus {
  PENDING = "Pendiente",
  CONFIRMED = "Confirmado",
  IN_TRANSIT = "En transito",
  DELIVERED = "Entregado",
  REJECTED = "Rechazado",
  NOT_DELIVERED = "No entregado",
  CANCELLED = "Cancelado",
}

export enum LegalOnboardingStatus {
  PENDING = "Pendiente",
  IN_REVIEW = "En revisión",
  REQUIRES_MODIF = "Requiere cambios",
  APPROVED = "Aprobado",
  PRELOADED = "Precargado",
}

export enum PurchaseOrderIntentStatus {
  PENDING = "Pendiente",
  IN_COMMUNICATION = "En comunicación",
  PRESENTED = "Presentada",
  CANCELLED = "Cancelada",
  REJECTED = "Rechazada",
}

export enum LegalOnboardingStatusId {
  PRELOADED = 195,
  PENDING = 196,
  IN_REVIEW = 197,
  REQUIRES_MODIF = 198,
  APPROVED = 199,
}

export enum LegalFileStatus {
  ACCEPTED = "Aceptado",
  REJECTED = "Rechazado",
}

export enum LegalFileStatusId {
  ACCEPTED = 200,
  REJECTED = 201,
}

export enum RequestTypes {
  CASH = 1,
  PHYSICAL_CHECK = 2,
  E_CHEQ = 3,
  SUPPLIES_REQUEST = 4,
  SUPPLIES_ORDER = 5,
}

export enum RequestTypeDescription {
  CASH = "Efectivo",
  PHYSICAL_CHECK = "Cheque Físico",
  E_CHEQ = "E-Cheq",
}

export enum ContactRequestStatus {
  PENDING = 1,
  CONTACTED = 2,
}

export enum FieldVisitStatus {
  PENDING_ASSIGNATION = "Pendiente de asignación",
  ASSIGNED = "Asignada",
  CANCELLED = "Cancelada",
  REJECTED = "Rechazada",
  DONE = "Realizada",
  CLOSED = "Cerrada",
}

export enum ProductPlanificationStatus {
  LOADED = "Cargada",
  PRESENTED = "Presentada",
  IN_REVISION = "Datos en revisión",
  CANCELLED = "Cancelada"
}
export enum LoadedTaxesStatus {
  PENDING = "Pendiente",
  PAID = "Cobrado",
  ERROR = "Error",
  FUND_IN_PROCESS ="Fondeo en proceso",
  FUNDED = "Fondeado",
  PAYMENT_IN_PROCESS = "Cobro en proceso",
}

export enum TaxesUploadStatus {
  PROCESSING = "Procesando",
  COMPLETED = "Completada",
  ERROR = "Error",
}

export enum ServiceRequestStatus {
  PENDING = "Pendiente",
  CANCELLED = "Cancelada",
  REJECTED = "Rechazada",
  DONE = "Realizado",
  CLOSED = "Cerrado",
}

export enum GrossMarginRequestStatus {
  PENDING = "Pendiente",
  IN_PROCESS = "En proceso",
  CONFIRMED = "Confirmada",
  CANCELLED = "Cancelada",
  REJECTED = "Rechazada",
}

export enum EstablishmentFieldRequestStatus {
  PENDING = "Pendiente",
  IN_REVIEW = "En revisión",
  CONFIRMED = "Confirmada",
  REJECTED = "Rechazada",
  CANCELLED = "Cancelada",
}
